module.exports = __webpack_public_path__ + "media/images/entidades_organizadoras/fct-658c1f86119b17ff133a84e43231c15f.svg";